import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tournament-content" }
const _hoisted_2 = {
  key: 0,
  class: "btn-join"
}
const _hoisted_3 = { class: "text-capitalize-first" }
const _hoisted_4 = {
  key: 1,
  class: "btn-join"
}
const _hoisted_5 = { class: "text-capitalize-first" }
const _hoisted_6 = {
  key: 2,
  class: "d-flex flex-column"
}
const _hoisted_7 = { class: "header ms-0" }
const _hoisted_8 = { class: "text-capitalize-first" }
const _hoisted_9 = { class: "d-flex flex-column current-combination" }
const _hoisted_10 = {
  key: 0,
  class: "combination-name"
}
const _hoisted_11 = {
  key: 1,
  class: "bets-to-next-card"
}
const _hoisted_12 = {
  key: 2,
  class: "previous-combination"
}
const _hoisted_13 = { class: "combination-name" }
const _hoisted_14 = {
  key: 3,
  class: "d-flex flex-column"
}
const _hoisted_15 = { class: "header ms-0" }
const _hoisted_16 = { class: "text-capitalize-first" }
const _hoisted_17 = {
  key: 4,
  class: "d-flex flex-column"
}
const _hoisted_18 = { class: "header ms-0" }
const _hoisted_19 = { class: "text-capitalize-first" }
const _hoisted_20 = { class: "rules" }
const _hoisted_21 = { class: "info" }
const _hoisted_22 = {
  key: 0,
  class: "item"
}
const _hoisted_23 = {
  key: 1,
  class: "item"
}
const _hoisted_24 = { class: "item" }
const _hoisted_25 = { class: "item" }
const _hoisted_26 = { class: "item" }
const _hoisted_27 = { class: "item" }
const _hoisted_28 = {
  class: "description",
  style: {"white-space":"pre-line"}
}

import {useStore} from "vuex";
import {numberFormatter} from "@/service/NumberFormatter";
import {computed, onMounted, onUnmounted, ref, watch} from "vue";
import LoaderContent from "@/components/LoaderContent.vue";
import {api} from "@/service/APIClient";
import TournamentLeaderboardDTO from "@/models/TournamentLeaderboardDTO";
import {reactive} from "@vue/reactivity";
import UserDTO from "@/models/UserDTO";
import TournamentDTO from "@/models/TournamentDTO";
import {TournamentStatus} from "@/models/enum/TournamentStatus";
import TournamentLeaderboard from "@/components/TournamentLeaderboard.vue";
import TournamentParticipantDTO from "@/models/TournamentParticipantDTO";
import {TournamentType} from "@/models/enum/TournamentType";
import PokerCombination from "@/components/PokerCombination.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'TournamentContent',
  props: {
    tournament: {}
  },
  setup(__props: any) {

const props = __props
const store = useStore()
const tournamentContentLoader = ref<InstanceType<typeof LoaderContent> | null>(null)

const top = computed(() => {
  return state.leaderboard?.top ?? []
})

const neighbors = computed(() => {
  return state.leaderboard?.neighbors ?? []
})

const participant = computed((): TournamentParticipantDTO|null => {
  return state.leaderboard?.participant as TournamentParticipantDTO|null
})

const userInTop = computed<boolean>(():boolean => {
  if (!store.getters.isLoggedIn) {
    return true;
  }

  for (const item of top.value) {
    if (item.userId === store.getters.getUser?.id) {
      return true;
    }
  }

  return false;
})

const state = reactive({
  leaderboard: null as TournamentLeaderboardDTO|null,
  leaderboardUpdateInterval: null as number|any,
})

const join = async () => {
  tournamentContentLoader.value?.load(async () => {
    await store.dispatch('joinTournament', props.tournament.id)
  });
}

onUnmounted(() => {
  clearInterval(state.leaderboardUpdateInterval)
})

onMounted(() => {
  tournamentContentLoader.value?.load(async () => {
    state.leaderboard = await api.call.tournaments.leaderboard(props.tournament.id)
  });
  state.leaderboardUpdateInterval = setInterval(async () => {
    state.leaderboard = await api.call.tournaments.leaderboard(props.tournament.id)
  }, 5000)
})

watch(() => props.tournament.id, async (newValue, oldValue) => {
  tournamentContentLoader.value?.load(async () => {
    state.leaderboard = await api.call.tournaments.leaderboard(props.tournament.id)
  });
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LoaderContent, {
    class: "",
    ref: (el) => tournamentContentLoader.value = el
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (props.tournament.status === _unref(TournamentStatus).ACTIVE && _unref(state).leaderboard && !(_unref(state).leaderboard as TournamentLeaderboardDTO|null)?.participant)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (join())),
                class: "btn btn-primary w-100"
              }, [
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('join')), 1)
              ])
            ]))
          : (props.tournament.status === _unref(TournamentStatus).ACTIVE && (_unref(store).getters.getUser as UserDTO|null)?.currentTournamentParticipant?.tournamentId !== props.tournament.id)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (join())),
                  class: "btn btn-primary w-100"
                }, [
                  _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('play')), 1)
                ])
              ]))
            : _createCommentVNode("", true),
        (props.tournament.type === _unref(TournamentType).POKER && props.tournament.status === _unref(TournamentStatus).ACTIVE && participant.value?.pokerCombination )
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('your_hand')), 1)
              ]),
              _createElementVNode("div", _hoisted_9, [
                (participant.value?.pokerCombination?.combination)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.$t(`poker_combinations.${participant.value.pokerCombination.combination}`)), 1))
                  : _createCommentVNode("", true),
                _createVNode(PokerCombination, {
                  class: "current",
                  pokerCombination: participant.value?.pokerCombination
                }, null, 8, ["pokerCombination"]),
                (participant.value?.pokerCombination && participant.value.pokerCombination.openCards.length < 5)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                      _createTextVNode(_toDisplayString(_ctx.$t('bets_to_next_card_prefix')) + " ", 1),
                      _cache[2] || (_cache[2] = _createElementVNode("img", {
                        src: "/img/coins/gold_coin.svg",
                        alt: "coin"
                      }, null, -1)),
                      _createElementVNode("span", null, _toDisplayString(_unref(numberFormatter).formatNumber(participant.value.pokerCombination.betsToNextCard)), 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('bets_to_next_card_suffix')), 1)
                    ]))
                  : _createCommentVNode("", true),
                (participant.value.previousPokerCombination && participant.value.previousPokerCombination.combination)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('previous_hand')) + ": " + _toDisplayString(_ctx.$t(`poker_combinations.${participant.value.previousPokerCombination.combination}`)), 1),
                      _createVNode(PokerCombination, {
                        pokerCombination: participant.value.previousPokerCombination
                      }, null, 8, ["pokerCombination"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        (participant.value && !userInTop.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('your_position')), 1)
              ]),
              _createVNode(TournamentLeaderboard, {
                leaderboard: neighbors.value,
                tournament: props.tournament
              }, null, 8, ["leaderboard", "tournament"])
            ]))
          : _createCommentVNode("", true),
        (top.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t('leaderboard')), 1)
              ]),
              _createVNode(TournamentLeaderboard, {
                leaderboard: top.value,
                tournament: props.tournament
              }, null, 8, ["leaderboard", "tournament"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t('rules')), 1),
          _createElementVNode("div", _hoisted_21, [
            (props.tournament.bankrollRatioType !== 'NONE')
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t('tournament.description.prize_pool_ratio')), 1),
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t(`tournament.ratio.${props.tournament.bankrollRatioType}`, {percent: props.tournament.bankrollRatio})), 1)
                ]))
              : _createCommentVNode("", true),
            (props.tournament.pointsRatioType !== 'NONE')
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t('tournament.description.score_accrual')), 1),
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t(`tournament.ratio.${props.tournament.pointsRatioType}`, {percent: props.tournament.pointsRatio})), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('tournament.description.start_bankroll')), 1),
              _createElementVNode("div", null, _toDisplayString(_unref(numberFormatter).formatNumber(props.tournament.startBankroll)), 1)
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('tournament.description.current_bankroll')), 1),
              _createElementVNode("div", null, _toDisplayString(_unref(numberFormatter).formatNumber(props.tournament.currentBankroll)), 1)
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('tournament.description.winners_count')), 1),
              _createElementVNode("div", null, _toDisplayString(_unref(numberFormatter).formatNumber(props.tournament.winnersCount)), 1)
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('tournament.description.duration')), 1),
              _createElementVNode("div", null, _toDisplayString(_unref(numberFormatter).formatNumber(props.tournament.duration)) + " min", 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_28, _toDisplayString(props.tournament.description), 1)
        ])
      ])
    ]),
    _: 1
  }, 512))
}
}

})